export default "__VITE_ASSET__ChsxyV6o__"